import React from 'react';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import cx from 'classnames';
import { ReactComponent as AgentIcon } from '../../design-system/design_system/assets/icons/system/live-chat.svg';


const Chat = (props) => {
  const {
    onlineButtonId,
    reactiveButtonId,
    offlineButtonId,
    feedbackClickToChat,
  } = props;


  return (
    <section id="c2c-container" className="c2cImgClass chat-container shadow-2">
      <Button
        id={onlineButtonId}
        variant="primary"
        className={cx('border-0 chat-icon bg-primary', { 'd-none': !reactiveButtonId || window.isChatOffline })}
        onClick={() => window.liveagent && window.liveagent.startChat(reactiveButtonId)}
        data-testid={onlineButtonId}
      >
        <AgentIcon className="agent-icon svg-fill-white" />
        <span className="live-chat p-2">{get(feedbackClickToChat, 'LiveChatText')}</span>
      </Button>
      <Button
        id={offlineButtonId}
        variant="primary"
        className="border-0 chat-icon d-none bg-primary"
        style={{ display: 'none' }}
        data-testid={offlineButtonId}
      >
        <AgentIcon className="agent-icon svg-fill-white" />
        <span className="live-chat p-2">
          {get(feedbackClickToChat, 'LiveChatText')}
        </span>
      </Button>
    </section>
  );
};

Chat.propTypes = {
  onlineButtonId: PropTypes.string.isRequired,
  offlineButtonId: PropTypes.string.isRequired,
  reactiveButtonId: PropTypes.string.isRequired,
  feedbackClickToChat: PropTypes.instanceOf(Object).isRequired,
};

export default Chat;
